/* eslint-disable no-inner-declarations */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import { i18n } from '@/i18n'
import { bus } from '@/main'
import helpers from '@/helpers'

const Trans = {
  get defaultLocale() {
    return process.env.VUE_APP_I18N_LOCALE
  },

  get supportedLocales() {
    return process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',')
  },

  get currentLocale() {
    return i18n.locale
  },

  set currentLocale(locale) {
    i18n.locale = locale
  },

  changeLocale(locale) {
    if (!Trans.isLocaleSupported(locale)) {
      return Promise.reject(false)
    }

    if (i18n.locale === locale) {
      return Promise.resolve(locale)
    }

    return Trans.loadLocaleFile(locale).then((msgs) => {
      i18n.setLocaleMessage(locale, msgs)
      return Trans.setI18nLocaleInServices(locale)
    })
  },

  isLocaleSupported(locale) {
    return this.supportedLocales.includes(locale)
  },

  loadLocaleFile(locale) {
    return import(`@/locales/${locale}.json`)
  },

  setJivoSiteLocale(locale) {
    if (typeof jivo_config !== 'undefined') {
      jivo_config.online_widget_label = i18n.t('interface.jivosite.title')
      jivo_config.custom_langpack = i18n.t('interface.jivosite.custom_langpack')
      jivo_config.prechat = i18n.t('interface.jivosite.prechat')
      // setTimeout(() => {
      //   jivo_api.showProactiveInvitation(
      //     i18n.t('interface.jivosite.invitation')
      //   )
      // }, 10000)

      function jivo_onLoadCallback() {
        jivo_destroy()
        console.log('Widget is deleted')
      }

      jivo_init()
    } else {
      setTimeout(() => {
        // Trans.setJivoSiteLocale(locale)
      }, 1000)
    }
  },

  setI18nLocaleInServices(locale) {
    Trans.currentLocale = locale
    document.querySelector('html').setAttribute('lang', locale)
    // Trans.setJivoSiteLocale(locale)
    return locale
  },
  // routeMiddleware() {},

  async routeMiddleware(to, from, next) {
    const locale = to.params.locale
    // Trans.setJivoSiteLocale(locale)
    let auth = localStorage.getItem('token')

    if (to.name === 'Referral' && to.params && to.params.referral) {
      if (!auth) {
        localStorage.setItem('referral', to.params.referral)
      } else {
        localStorage.removeItem('referral')
        if (to.params.locale && Trans.isLocaleSupported(locale)) {
          return Trans.changeLocale(locale).then(() =>
            next(
              helpers.buildRoute({
                name: 'HomeLoc',
                params: {
                  toPage: to,
                  locale: to.params.locale,
                },
              })
            )
          )
        } else {
          return next(
            helpers.buildRoute({
              name: 'Home',
              params: { toPage: to },
            })
          )
        }
      }
    }
    if (to.meta.auth && !auth) {
      if (from.name) {
        bus.$emit('openAuth', 'authSSOState', true, to)
        return false
      } else {
        if (to.params.locale && Trans.isLocaleSupported(locale)) {
          return Trans.changeLocale(locale).then(() =>
            next(
              helpers.buildRoute({
                name: 'HomeLoc',
                params: {
                  showAuth: true,
                  toPage: to,
                  locale: to.params.locale,
                },
              })
            )
          )
        } else {
          return next(
            helpers.buildRoute({
              name: 'Home',
              params: { showAuth: true, toPage: to },
            })
          )
        }
      }
    } else {
      if (to.params.locale === Trans.defaultLocale && to.name.includes('Loc')) {
        delete to.params.locale
        return next({ ...to, name: to.name.replace('Loc', '') })
      } else if (to.params.locale && Trans.isLocaleSupported(locale)) {
        return Trans.changeLocale(locale).then(() => next())
      } else if (to.params.locale && !Trans.isLocaleSupported(locale)) {
        delete to.params.locale
        return next({ ...to, name: to.name.replace('Loc', '') })
      } else {
        return next()
      }
    }
    // if (!Trans.isLocaleSupported(locale)) return next(Trans.defaultLocale)
    // return Trans.changeLocale(locale).then(() => next())
  },

  // routerWithoutLocMiddleware(to, from, next) {
  //   to.params.locale = 'ru'
  //   const locale = to.params.locale
  //   if (i18n.locale !== locale) i18n.locale = locale
  //   return next()
  // },

  i18nRoute(to) {
    return {
      ...to,
      params: { locale: this.currentLocale, ...to.params },
    }
  },
}

export { Trans }
